import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ["Mujeres latinas que despiertan con el abdomen plano pero terminan el día con 'panza de embarazo'.", 'Personas con diagnóstico de colon irritable o sensibilidad al gluten que buscan una solución práctica.', 'Quienes sufren de cansancio crónico y pesadez justo después de comer.', 'Madres y profesionales que no tienen tiempo de cocinar platos complicados o caros.'];
  const isNotFor = ["Personas que buscan una 'pastilla mágica' para bajar de peso sin cambiar lo que ponen en su plato.", 'Quienes no están dispuestos a probar nuevos ingredientes de cocina por solo 7 días.', 'Personas con trastornos alimentarios graves que requieren supervisión clínica personalizada.'];
  return <section className="bg-sage py-20 md:py-28" data-id="element-186">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-187">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-188">
          {/* IS FOR */}
          <div className="bg-white p-8 md:p-10 rounded-sm shadow-md border-t-4 border-forest" data-id="element-189">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-forest mb-8 flex items-center gap-3" data-id="element-190">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-191">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-192">
                  <CheckCircle className="w-6 h-6 text-forest mt-1 flex-shrink-0" strokeWidth={2} data-id="element-193" />
                  <p className="text-dark/80 font-body leading-relaxed" data-id="element-194">
                    {item}
                  </p>
                </li>)}
            </ul>
          </div>

          {/* IS NOT FOR */}
          <div className="bg-cream p-8 md:p-10 rounded-sm shadow-sm border-t-4 border-red-800/40 opacity-90" data-id="element-195">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-dark/60 mb-8 flex items-center gap-3" data-id="element-196">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-197">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-198">
                  <XCircle className="w-6 h-6 text-red-800/40 mt-1 flex-shrink-0" strokeWidth={2} data-id="element-199" />
                  <p className="text-dark/60 font-body leading-relaxed" data-id="element-200">
                    {item}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}